<template>
  <div id="myContacts">
    <div class="dashboard-headline py-3">
      <div class="row justify-content-center">
        <div class="text-right px-2">
          <Btn 
          @click.native="isAddMode = true"          
          :label="$t('contacts.addNewContact')"
          fix-width
          />

         
          
        </div>
      </div>
    </div>
    <div class="container mb-2 mt-2">
      <div class="row mt-2 direction-column" v-if="isUploadMode">
        <div class="row">
          <div class="col-12 text-left">
            {{ $t('contacts.uploadNote1') }}
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-left">
            {{ $t('contacts.uploadNote2') }}
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-left">
            {{ $t('contacts.uploadNote3') }}
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-left">
            {{ $t('contacts.uploadNote4') }}
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-left">
            <form
              enctype="multipart/form-data"
              novalidate
              v-if="isInitial || isSaving"
            >
              <div class="dropbox">
                <input
                  type="file"
                  :name="uploadFieldName"
                  :disabled="isSaving"
                  @change="
                    filesChange($event.target.name, $event.target.files);
                    fileCount = $event.target.files.length;
                  "
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msexcel, text/comma-separated-values"
                  class="input-file"
                />
                <p v-if="isInitial">
                  {{ $t('contacts.dropboxNotice1') }}<br />
                  {{ $t('contacts.dropboxNotice2') }}<br />
                  {{ isSaving }}
                </p>
                <p v-if="isSaving">{{ $t('contacts.uploading') }}</p>
              </div>
            </form>
          </div>
        </div>
        <!--FAILED-->
        <div v-if="isFailed">
          <h2>{{ $t('contacts.uploadFailed') }}</h2>
          <p>
            <a href="javascript:void(0)" @click="reset()">
              {{ $t('contacts.tryAgain') }}</a
            >
          </p>
          <pre>{{ uploadError }}</pre>
        </div>
        <div class="row mt-1">
          <div class="col-12">
            <button class="btn btn-primary btn-sm" @click="cancelUpload">
              <font-awesome-icon
                class="text-white mx-2"
                :icon="['fal', 'times']"
              />
              {{ $t('contacts.cancel') }}
            </button>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row mt-2" v-if="!isAddMode">
          <div class="col-4">
            <button
              class="btn btn-primary full-height w-100 btn-sm"
              @click="isAddMode = true"
            >
              <font-awesome-icon
                class="text-white mx-2"
                :icon="['fal', 'plus-circle']"
              />
              <span class="d-none d-md-inline">
                {{ $t('contacts.addNewContact') }}
              </span>
            </button>
          </div>
          <div class="col-4">
            <button
              class="btn btn-primary full-height w-100 btn-sm"
              @click="uploadFile"
            >
              <font-awesome-icon
                class="text-white mx-2"
                :icon="['fal', 'file-excel']"
              />
              <span class="d-none d-md-inline text-white">
                {{ $t('contacts.fileUpload') }}
              </span>
            </button>
          </div>
          <div class="col-4">
            <button
              class="btn btn-primary full-height w-100 btn-sm"
              @click="deleteAll"
            >
              <font-awesome-icon
                class="text-white mx-2"
                :icon="['fal', 'trash-alt']"
              />
              <span class="d-none d-md-inline">
                {{ $t('contacts.deleteAllContacts') }}
              </span>
            </button>
          </div>
        </div>

        <div class="row mt-4" v-if="isAddMode">
          <div class="col-12">
            <h4>
              {{ $t('contacts.newContact') }}
            </h4>

            <div class="form-group row">
              <label for="name" class="col-2 col-form-label text-right">{{
                $t('contacts.name')
              }}</label>

              <div class="col-10 col-lg-8">
                <input
                  type="text"
                  name="name"
                  id="name"
                  class="form-control"
                  :placeholder="$t('contacts.name')"
                  v-model="addContactObj.name"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="email" class="col-2 col-form-label text-right">{{
                $t('contacts.email')
              }}</label>

              <div class="col-10 col-lg-8">
                <input
                  type="text"
                  name="email"
                  id="email"
                  class="form-control"
                  :placeholder="$t('contacts.email')"
                  v-model="addContactObj.email"
                />
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-4">
                <button
                  class="btn btn-primary full-height w-100 btn-sm"
                  @click="cancelAdd(true)"
                >
                  <font-awesome-icon
                    class="text-white mx-2"
                    :icon="['fal', 'times']"
                  />
                  {{ $t('contacts.cancel') }}
                </button>
              </div>
              <div class="col-4">
                <button
                  class="btn btn-primary full-height w-100 btn-sm"
                  @click="addContact(true)"
                >
                  <font-awesome-icon
                    class="text-white mx-2"
                    :icon="['fal', 'save']"
                  />
                  {{ $t('contacts.save') }}
                </button>
              </div>
              <div class="col-4">
                <button
                  class="btn btn-primary full-height w-100 btn-sm"
                  @click="addContact(false)"
                >
                  <font-awesome-icon
                    class="text-white mx-2"
                    :icon="['fal', 'save']"
                  />
                  <font-awesome-icon
                    class="text-white mx-2"
                    :icon="['fal', 'plus-circle']"
                  />
                  <font-awesome-icon
                    class="text-white mx-2"
                    :icon="['fal', 'user-plus']"
                  />
                  {{ $t('contacts.saveAndAdd') }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group row mt-4" v-if="!isAddMode">
          <label
            for="search"
            class="col-2 col-sm-4 col-form-label text-right"
            >{{ $t('contacts.search') }}</label
          >

          <div class="col-10 col-sm-8 col-lg-6">
            <input
              type="text"
              name="search"
              id="search"
              class="form-control"
              :placeholder="$t('contacts.searchPlaceholder')"
              v-model="searchText"
            />
          </div>
        </div>

        <div class="row" v-if="!isAddMode">
          <div class="col-12">
            <div class="table-responsive-xl table-wrapper">
              <table class="table table-striped">
                <thead class="bg-primary text-white">
                  <tr class="table-row text-nowrap">
                    <th class="d-none d-sm-table-cell">
                      <!--{{ $t('contacts.portrait') }}-->
                    </th>
                    <th @click="sortBy('name')" class="sortable">
                      {{ $t('contacts.name') }}
                      <span
                        class="arrow"
                        :class="sortOrders.name > 0 ? 'asc' : 'dsc'"
                      >
                      </span>
                    </th>
                    <th @click="sortBy('email')" class="sortable">
                      {{ $t('contacts.email') }}
                      <span
                        class="arrow"
                        :class="sortOrders.email > 0 ? 'asc' : 'dsc'"
                      >
                      </span>
                    </th>
                    <th
                      @click="sortBy('status')"
                      class="sortable d-none d-sm-table-cell"
                    >
                      {{ $t('contacts.status') }}
                      <span
                        class="arrow"
                        :class="sortOrders.status > 0 ? 'asc' : 'dsc'"
                      >
                      </span>
                    </th>
                    <th>
                      {{ $t('contacts.actions') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="table-row"
                    v-for="contact in filteredContacts"
                    :key="contact.id"
                  >
                    <td class="d-none d-sm-table-cell align-middle">
                      <img
                        v-if="contact.hasProfileImage"
                        :src="getImageUrl(contact.id)"
                        alt="Profile image"
                      />
                      <div v_else class="number-circle">
                        {{ getInitials(contact.name) }}
                      </div>
                    </td>
                    <td class="table-cell align-middle">
                      <span v-if="editContactObj.id !== contact.id">
                        {{ contact.name }}
                      </span>
                      <input
                        v-else
                        type="text"
                        name="editContactName"
                        id="editContactName"
                        class="form-control"
                        v-model.trim="editContactObj.name"
                      />
                    </td>
                    <td class="table-cell align-middle">
                      <div
                        class="d-inline-block text-truncate"
                        style="max-width: 30vw;"
                        v-if="editContactObj.id !== contact.id"
                      >
                        {{ contact.email }}
                      </div>
                      <input
                        v-else
                        type="text"
                        name="editContactEmail"
                        id="editContactEmail"
                        class="form-control"
                        v-model.trim="editContactObj.email"
                      />
                    </td>

                    <td class="d-none d-sm-table-cell align-middle">
                      {{ contact.status }}
                    </td>
                    <td class="align-middle">
                      <div
                        class="d-flex justify-content-around align-items-sm-center flex-column flex-sm-row"
                      >
                        <font-awesome-icon
                          @click="saveContact(contact)"
                          class="my-3 my-sm-0 pointer"
                          v-if="editContactObj.id === contact.id"
                          :icon="['fal', 'save']"
                          :style="{ color: saveColor }"
                          size="2x"
                        />
                        <font-awesome-icon
                          @click="cancelEdit()"
                          class="my-3 my-sm-0 pointer"
                          v-if="editContactObj.id === contact.id"
                          :icon="['fal', 'times']"
                          size="2x"
                        />
                        <font-awesome-icon
                          @click="editContact(contact)"
                          class="my-3 my-sm-0 pointer"
                          v-if="editContactObj.id !== contact.id"
                          :icon="['fal', 'pencil']"
                        />
                        <font-awesome-icon
                          @click="deleteContact(contact.id)"
                          class="mb-3 mb-sm-0 pointer"
                          :icon="['fal', 'trash-alt']"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP } from '@/shared/http';
import shared from '@/shared.js';
const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  data() {
    let sortOrders = {};
    sortOrders.name = 1;
    sortOrders.email = 1;
    sortOrders.polls_count = 1;
    sortOrders.status = 1;
    return {
      contacts: [],
      sortKey: '',
      sortOrders: sortOrders,
      searchText: '',
      searchKeys: ['name', 'email', 'status', 'polls_count'],
      editContactObj: { id: null, name: null, email: null },
      addContactObj: { name: null, email: null },
      isAddMode: false,
      isUploadMode: false,
      uploadedFiles: [],
      uploadError: null,
      currentUploadStatus: null,
      uploadFieldName: 'contacts',
    };
  },
  methods: {
    sortBy: function (key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },
    getImageUrl(id) {
      return '@/userImages/' + id + '.png';
    },
    editContact(contact) {
      this.editContactObj.id = contact.id;
      this.editContactObj.name = contact.name;
      this.editContactObj.email = contact.email;
    },
    cancelEdit() {
      this.editContactObj.id = null;
      this.editContactObj.name = null;
      this.editContactObj.email = null;
    },
    cancelAdd(quitAdd) {
      this.addContactObj.name = null;
      this.addContactObj.email = null;
      this.isAddMode = !quitAdd;
    },
    cancelUpload() {
      this.isUploadMode = false;
    },
    saveContact() {
      if (this.editContactObj.name && this.editContactObj.email) {
        const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
        const url = apiUrl + '/contact/' + this.editContactObj.id;
        console.log('SaveContact with the following Url:' + url);

        HTTP.put(url, {
          name: this.editContactObj.name,
          email: this.editContactObj.email,
        })
          .then((response) => {
            console.log('Processing the loaded contacts:', response);
            this.contacts = response.data;
            localStorage.setItem('contacts', JSON.stringify(this.contacts));
            this.cancelEdit();
          })
          .catch((error) => console.log(error));
      }
    },
    addContact(quitAdd) {
      if (this.addContactObj.name && this.addContactObj.email) {
        const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
        const url = apiUrl + '/contact';
        console.log('addContact with the following Url:' + url);

        HTTP.post(url, {
          name: this.addContactObj.name,
          email: this.addContactObj.email,
        })
          .then((response) => {
            console.log('Processing the loaded contacts:', response);
            this.contacts = response.data;
            localStorage.setItem('contacts', JSON.stringify(this.contacts));
            this.cancelAdd(quitAdd);
          })
          .catch((error) => console.log(error));
      }
    },
    deleteContact(id) {
      this.$dialog
        .confirm(this.$t('contacts.confirmDeleteContact', { loader: true }))
        .then((dialog) => {
          const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
          const url = apiUrl + '/contact/' + id;
          console.log('deleteContact with the following Url:' + url);

          HTTP.delete(url)
            .then((response) => {
              console.log('Delete response:', response);
              let deletedIndex = this.contacts.findIndex(
                (item) => item.id === id
              );
              if (deletedIndex > -1) {
                this.contacts.splice(deletedIndex, 1);
                localStorage.setItem('contacts', JSON.stringify(this.contacts));
              }
              dialog.close();
            })
            .catch((error) => console.log(error));
        })
        .catch(() => {});
    },
    uploadFile() {
      this.reset();
      this.isUploadMode = true;
    },
    deleteAll() {
      this.$dialog
        .confirm(this.$t('contacts.confirmDeleteContacts', { loader: true }))
        .then((dialog) => {
          const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
          const url = apiUrl + '/contacts';
          console.log('deleteContacts with the following Url:' + url);
          const checkCount = this.contacts.length;
          HTTP.delete(url)
            .then((response) => {
              console.log('Delete response:', response);
              if (response.status === 200) {
                let deleteCount = response.data.deleteCount;
                if (
                  deleteCount &&
                  deleteCount > 0 &&
                  deleteCount === checkCount
                ) {
                  this.contacts = [];
                  localStorage.setItem(
                    'contacts',
                    JSON.stringify(this.contacts)
                  );
                }
              } else {
                console.log(
                  'Error deleting contracts. Status: ',
                  response.status,
                  ' Message:',
                  response.data.message,
                  ', DeleteCount:',
                  response.data.deleteCount
                );
              }

              dialog.close();
            })
            .catch((error) => console.log(error));
        })
        .catch(() => {});
    },

    reset() {
      // reset form to initial state
      this.currentUploadStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },

    saveUpload(formData) {
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/contacts/upload';

      HTTP.post(url, formData)
        .then((response) => {
          console.log('Processing the loaded contacts:', response);
          this.isUploadMode = false;
          this.currentUploadStatus = STATUS_SUCCESS;
          this.getContacts();
        })
        .catch((err) => {
          this.uploadError = err.response;
          this.currentUploadStatus = STATUS_FAILED;
        });
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData();
      if (!fileList.length) return;
      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map((x) => {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });
      // save it
      this.saveUpload(formData);
    },
    getContacts() {
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/contacts';
      console.log('Using the followingUrl:' + url);
      HTTP.get(url)
        .then((response) => {
          console.log('Processing the loaded contacts:', response);
          this.contacts = response.data;
          localStorage.setItem('contacts', JSON.stringify(this.contacts));
        })
        .catch((error) => console.log(error));
    },
  },
  computed: {
    filteredContacts: function () {
      let sortKey = this.sortKey || 'name';
      let filterKey = this.searchText && this.searchText.toLowerCase();
      let order = this.sortOrders[sortKey] || 1;
      let contacts = this.contacts;
      let searchKeys = this.searchKeys;
      if (filterKey) {
        contacts = contacts.filter(function (contact) {
          return Object.keys(contact).some(function (key) {
            return (
              searchKeys.includes(key) &&
              String(contact[key]).toLowerCase().indexOf(filterKey) > -1
            );
          });
        });
      }
      if (sortKey) {
        contacts = contacts.slice().sort(function (a, b) {
          a = a[sortKey];
          b = b[sortKey];
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }
      return contacts;
    },
    saveColor() {
      return this.editContactObj.name && this.editContactObj.email
        ? 'green'
        : 'red';
    },
    isInitial() {
      return this.currentUploadStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentUploadStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentUploadStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentUploadStatus === STATUS_FAILED;
    },
  },

  created() {
    this.getInitials = shared.getInitials;
  },

  mounted() {
    this.lastUpdate = shared.lastUpdate;
    this.reset();
    const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
    const url = apiUrl + '/contacts';
    console.log('Using the followingUrl:' + url);

    const contactsLoaded = localStorage.getItem('contacts');
    if (contactsLoaded) {
      console.log('read contacts from local storage');
      this.contacts = JSON.parse(contactsLoaded);
    }

    HTTP.get(url)
      .then((response) => {
        console.log('Processing the loaded contacts:', response);
        this.contacts = response.data;
        localStorage.setItem('contacts', JSON.stringify(this.contacts));
      })
      .catch((error) => console.log(error));

    console.log('mount completed');
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #000000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #000000;
}

.sortable {
  cursor: pointer;
}

.direction-column {
  flex-direction: column;
}

.dropbox {
  outline: 2px dashed grey;
  outline-offset: -10px;
  background: #cccccc;
  color: black;
  padding: 10px 10px;
  min-height: 200px;
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0;
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
}

.dropbox:hover {
  background: #aaaaaa;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

.number-circle {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  padding-left: 0px;
  padding-top: 8px;
  display: block;
  background: $user-bubble;
  border: 0px solid;
  color: $dark-grey;

  text-align: center;
  font: 14px Arial, sans-serif;
  margin: auto;
}


.btn.full-height {
  min-height: 100%;
}

</style>
